/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, EventEmitter, Output } from '@angular/core';
import {
  ContactDetailsDialogConfig,
  contactDetailsDialogRoute,
} from '@gh/builder-shared';
import {
  AbstractSnapshotFormComponent,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
} from '@gh/common-shared';
import { DialogService, setControlValue } from '@gh/core-ui';
import { filter$ } from '@gh/rx/operators';
import { JobCoMasterInfo, JobListItem } from '../../../resources/job.model';
import { ContactType } from '@gh/builder-shared-data';

@Component({
  standalone: false,
  selector: 'gh-job-co-top-form',
  templateUrl: 'job-co-top-form.component.html',
  styleUrls: ['./job-co-top-form.component.scss'],
})
export class JobCoTopFormComponent extends AbstractSnapshotFormComponent<JobCoMasterInfo> {
  @Output() jobSelect = new EventEmitter<JobListItem>();

  constructor(private formStateBuilder: FormStateBuilder,
              private dialogService: DialogService) {
    super();
  }

  openContact(): void {
    this.dialogService.openWithInput(contactDetailsDialogRoute, <ContactDetailsDialogConfig>{
      contactType: ContactType.Customer,
      contactId: this.state.value.contactId,
      parentTitle: 'lbl_job',
    }).afterClosed().pipe(
      filter$(Boolean))
      .subscribe((contact: any) => {
        setControlValue(this.form.group, 'contactName', contact.name);
        this.state.value.contactId = contact.contactId;
      });
  }

  protected buildForm(snapshot: FormStateSnapshot<JobCoMasterInfo>): FormState<JobCoMasterInfo> {
    return this.formStateBuilder.buildPlain({
      mode: this.mode,
      enabled: true,
      snapshot,
      children: {
        job: { enabled: false },
        contactName: { enabled: false },
        siteAddress: { enabled: false },
      },
    });
  }
}
